<template>
	<div class="">
		<section class="section header" :class="{'is-hidden-mobile is-hidden-tablet-only' : loggedIn}">
			<div class="background-semidark">
				<div class="container">
					<div class="columns">
						<div class="column is-4-tablet is-hidden-mobile">
							<router-link to="/">
								<img src="@/assets/img/logoblanco.png" alt="" class="logo">
							</router-link>
						</div>
						<div class="column is-8-tablet header-mobile">
							<div class="level is-mobile">
								<div class="level-item">
									<h2 class="truncate is-hidden-mobile">Tu lugar para hacer quinielas gratis y divertirte</h2>
									<router-link to="/">
										<img src="@/assets/img/android-chrome-48x48.png" alt="" class="logo-mobile is-hidden-tablet">
									</router-link>
									<div class="is-hidden-tablet">
										<img src="@/assets/img/quiniblanco.svg" alt="">
										<h3 class="subtitle is-7">Tu lugar para hacer quinielas gratis y divertirte</h3>
									</div>
								</div>
							</div>
							<div class="columns is-mobile" v-if="!loggedIn">
								<div class="column is-2 is-hidden-mobile"></div>
								<div class="column is-5-tablet is-6-mobile">
									<h5 class="is-hidden-mobile">Soy nuevo!!</h5>
									<button class="button is-info is-small is-fullwidth" @click.prevent="openRegister">Registrate</button>
								</div>
								<div class="column is-5-tablet is-6-mobile">
									<h5 class="is-hidden-mobile">Ya soy miembro!!</h5>
									<button class="button is-info is-small is-fullwidth" @click.prevent="openLogin">Inicia Sesion</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		

		<!-- Navigation -->
		<nav class="navbar is-dark" :class="{'is-fixed-top' : this.windowWidth < 1024}" v-if="loggedIn">
			<div class="container">
				<div class="navbar-start is-hidden-desktop">
					<div class="navbar-item">
						<div class="buttons">
							<button v-if="!backVisible" ref="btnAsideMenu" class="button navbar-item is-dark" @click.prevent="toggleMenu()"><font-awesome-icon icon="bars" /></button>
							<button v-if="backVisible" class="button navbar-item is-dark" @click.prevent="goBack()"><font-awesome-icon icon="arrow-left" /></button>
						</div>
					</div>
				</div>
				<div class="navbar-brand is-hidden-desktop">
					<router-link class="navbar-item" to="/jugar">
						<!-- <img src="@/assets/img/logofb.gif" alt=""> -->
						<img src="@/assets/img/quiniblanco.svg" width="120em" alt="">
					</router-link>
				</div>
				

				<div class="navbar-menu quinielazo-menu" :class="{'is-active' : openMenu}">
					<div class="navbar-start is-hidden-mobile is-hidden-tablet-only">
						<router-link class="navbar-item" to="/jugar">Inicio</router-link>
						<router-link class="navbar-item" to="/mis-quinielas">Mis Quinielas</router-link>
						<router-link class="navbar-item" to="/quinielas-publicas">Quinielas Públicas</router-link>
						<router-link class="navbar-item" to="/puntos">Puntos</router-link>
						
						<a href="#" @click.prevent="logout" class="navbar-item">Salir</a>
						
					</div>
					<div class="navbar-end">
						<router-link class="navbar-item is-hidden-mobile is-hidden-tablet-only" to="/buscar">
							<font-awesome-icon icon="search" />
						</router-link>
						<NotificationsButton />
					</div>
				</div>
			</div>
		</nav>

	</div>

</template>

<script>
	import { mapGetters, mapState } from 'vuex'
	import NotificationsButton from '@/components/NotificationsButton'
	export default {
		components: { NotificationsButton },
		props: {
			windowWidth: {
				type: Number,
				required: true
			}
		},
		name: 'Header',

		data() {
			return {
				openMenu: false
			};
		},
		methods: {
			toggleMenu(){
				this.$emit('toggleMenu')
			},
			logout(){
				this.$store.dispatch('logout')
			},
			openRegister(){
				this.$emit('openRegister')
			},
			openLogin(){
				this.$emit('openLogin')
			},
			goBack(){
				history.back()
				//this.$router.push({name: 'jugar'})
			}
		},
		computed: {
			...mapGetters(['loggedIn']),
			...mapState('user',['user']),
			backVisible(){
				let urls = ['seguidores','perfil','ver-quiniela','estadistica','reglas','configuracion','ayuda','puntos'];
				return urls.includes(this.$route.name)
			}
		}
	};
</script>

<style lang="css" scoped>
.navbar-brand{
	justify-content: center;
	flex-grow: 1;
}
.header {
	background: url(~@/assets/img/fondodelgado.jpg) no-repeat center center;
	background-size: cover;
	border-bottom: #090 5px solid;
	box-shadow: 0px 3px 5px #000000;
	margin-bottom: 0px;
	position: relative;
	padding: 0;
	z-index: 1;
}
.slogan{
	vertical-align: top;
	display: inline-block;
}
.slogan2{
	margin: 5px 0px 0px 0px;
	text-align: right;
}
h2 {
	color: #FFF;
	font: 30px 'Shadows Into Light Two', cursive;
	text-shadow: 2px 1px 2px #333;
	text-align: right;
}
h5{
	color: orange;
	font-size: 14px;
	margin: 10px 0;
	font-weight: bold;
	text-shadow: 2px 1px #333;
}
@media (max-width: 769px) {
	.level-right{
		/*min-width: 0;*/
		/*word-wrap: break-word;*/
		flex-basis: 77%;
	}
	.level-right .level-item{
		flex-shrink: 1;
		text-align: left !important;
		/*padding: .5em .5em;*/
	}
	h2{
		text-align: left;
		font-size: 1.6em;
	}
	.header-mobile .level-right{
		flex-basis: auto;
	}
}
.navbar-burger{
	margin-left: unset;
}
.header-mobile{
	padding: 0;
}
.background-semidark{
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.5) !important;
	padding: 1rem 1.5rem;
}
.subtitle{
	color: white;
}
.logo-mobile{
	margin-right: 1em;
}
</style>
